import { messaging } from "../config/firebaseConfig";
import { getToken } from "firebase/messaging";
import axios from "axios";
import { BASE_API_URL } from "./constants";
import { CONFIG } from "../info";

export const requestFirebaseToken = async (
  userId: number,
  jwtToken: string
) => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    try {
      const firebaseToken = await getToken(messaging, {
        vapidKey: CONFIG.firebase.vapidKey,
      });
      console.log("FCM Token:", firebaseToken);
      await saveTokenToServer(userId, firebaseToken, jwtToken);
    } catch (error) {
      console.error("Unable to get FCM token", error);
    }
  } else {
    console.error("Notification permission denied.");
  }
};

const saveTokenToServer = async (
  userId: number,
  firebaseToken: string,
  jwtToken: string
) => {
  await axios.post(
    `${BASE_API_URL}/api/v1/notification/saveNotificationToken`,
    {
      userId,
      notificationToken: firebaseToken,
    },
    {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
};
